import { createSelector } from 'reselect'

import {
  props,
  networkProps,
  networkErrors,
  networkLoading,
} from './utils'

const store = state => state.user
const meta = createSelector(
  store,
  u => u.data ? u.data.meta || {} : {}
)
const activeProjectId = createSelector(meta, meta => meta.activeProject)
const loggedIn = createSelector(store, u => u.data ? true : false)

const NETWORK_NAMES = networkProps('user', [
  'status',
  'logout',
  'loadToken',
])

export default {
  store,
  meta,
  loggedIn,
  activeProjectId,
  errors: props(networkErrors, NETWORK_NAMES),
  loading: props(networkLoading, NETWORK_NAMES),
  ...props(store, [
    'data',
    'loaded',
    'token',
  ]),
}
